import { TaskItem as TiptapTaskItem } from "@tiptap/extension-list"

export const TaskItem = TiptapTaskItem.extend({
  parseHTML() {
    return [
      {
        tag: `li[data-type="${this.name}"]`,
        priority: 51,
        // renderHTML wraps item content in a <div>. Without contentElement,
        // the generic html-preservation Div node claims that wrapper on
        // source-editor save and lifts it out of the list — duplicating a
        // wrapping <div> (and an empty paragraph) each round-trip.
        contentElement: (element) => element.querySelector(":scope > div") || element,
      },
    ]
  },
})

export default TaskItem
